module.exports = __webpack_public_path__ + "static/media/lazyaz_app4.1c42fb15.jpg";